var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var Pipe_1;
/* eslint-disable import/no-duplicates */
import { Utils } from '@symon-ai/wisepipe-common';
import { DateConverter, JSON, JsonConverter, JsonSchemaV2 } from '@symon-ai/wisepipe-serialize';
import './pipeDocumentation'; // force import for JsonSchemaV2
import './challengeData';
import { pipeSchemaValidation } from '../validations.generated';
export var EngineMode;
(function (EngineMode) {
    EngineMode["Standard"] = "standard";
    EngineMode["Big"] = "big";
})(EngineMode || (EngineMode = {}));
const NAME_MAX_LENGTH = 100;
export const pipeSchema = {
    $id: 'urn:wisepipe-base-pipe:Pipe',
    type: 'object',
    properties: {
        pipeID: { type: 'string', uid: 10 },
        name: { type: 'string', minLength: 1, maxLength: NAME_MAX_LENGTH },
        engineMode: { type: 'string', enum: Object.values(EngineMode) },
        createdAt: { type: 'string', format: 'date-time' },
        description: { type: 'string', maxLength: 1000 },
        documentation: { $ref: 'urn:wisepipe-base-pipe:PipeDocumentation' },
        image: { type: 'string', maxLength: 1024 },
        imageUrl: { type: 'string' },
        rowVersion: { type: 'number', minimum: 0 },
        challengeData: { $ref: 'urn:wisepipe-base-pipe:ChallengeData' },
        parentFolderID: { type: 'string', uid: 9 },
        isEditor: { type: 'boolean' },
        isPublic: { type: 'boolean' }
    },
    required: ['pipeID', 'name', 'createdAt', 'engineMode', 'rowVersion']
};
let Pipe = Pipe_1 = class Pipe {
    constructor(pipeID, name, engineMode, description, createdAt, documentation, image, rowVersion = 0, challengeData, parentFolderID, isEditor, isPublic) {
        this.pipeID = pipeID;
        this.name = name;
        this.engineMode = engineMode;
        this.createdAt = createdAt ?? new Date();
        if (description)
            this.description = description;
        if (documentation)
            this.documentation = documentation;
        if (image)
            this.image = image;
        this.rowVersion = rowVersion;
        this.challengeData = challengeData;
        if (parentFolderID)
            this.parentFolderID = parentFolderID;
        this.isEditor = isEditor;
        this.isPublic = isPublic;
        JSON.validate(this, Pipe_1);
    }
    /** Validate the pipeID, and optionally the name and/or rowVersion */
    static validate(pipeID, name, image, rowVersion) {
        new Pipe_1(pipeID, name !== undefined ? name : 'valid name', EngineMode.Standard, undefined, undefined, undefined, image ?? 'valid.png', rowVersion ?? 0);
    }
    static newID() {
        return Utils.newID(10);
    }
    static bufferID(base64FileID) {
        return Utils.base64StringToBuffer(base64FileID);
    }
};
Pipe.NAME_MAX_LENGTH = NAME_MAX_LENGTH;
__decorate([
    JsonConverter(new DateConverter('date-time'))
], Pipe.prototype, "createdAt", void 0);
Pipe = Pipe_1 = __decorate([
    JsonSchemaV2(pipeSchema, pipeSchemaValidation)
], Pipe);
export { Pipe };
(function (Pipe) {
    function parseEngineMode(mode) {
        for (const key in EngineMode) {
            if (EngineMode[key] === mode) {
                return EngineMode[key];
            }
        }
        return undefined;
    }
    Pipe.parseEngineMode = parseEngineMode;
})(Pipe || (Pipe = {}));
//# sourceMappingURL=pipe.js.map